import { z } from 'zod';
import { AdminActionInput } from '../shared.js';
import { PolicyKind } from '../../help.js';
import { Category1, Category2 } from '../../taxonomy.js';
import { HttpUrl } from '../../common/url.js';
// ── content ops (FR-ADM-60…65) ────────────────────────────────────────────
export const PublishPolicyInput = AdminActionInput.extend({
    kind: PolicyKind,
    title: z.string().min(1).max(160),
    bodyMarkdown: z.string().min(1),
    effectiveAt: z.coerce.date(),
});
export const UpsertFaqInput = AdminActionInput.extend({
    id: z.string().optional(),
    group: z.string().min(1).max(60),
    question: z.string().min(1).max(200),
    answerMarkdown: z.string().min(1),
    order: z.number().int().default(0),
    published: z.boolean().default(true),
});
export const UpsertTemplateInput = AdminActionInput.extend({
    id: z.string().optional(),
    name: z.string().min(1).max(60),
    // Allowlisted like every other member-visible url: the console renders this,
    // and `notification:template:manage` can be granted to a custom role that
    // holds nothing else, so an admin action is not automatically trusted input.
    previewUrl: HttpUrl,
    minTierIndex: z.number().int().min(0).max(9),
    active: z.boolean().default(true),
});
/** Targeting only — previewing an audience is a read, no reason required. */
export const BroadcastTarget = z.object({
    category1: Category1.optional(),
    category2: Category2.optional(),
    minTierIndex: z.number().int().min(0).max(9).optional(),
});
export const BroadcastInput = AdminActionInput.extend({
    title: z.string().min(1).max(120),
    body: z.string().min(1).max(1_000),
}).merge(BroadcastTarget);
export const BroadcastPreview = z.object({ audienceSize: z.number().int() });
export const BroadcastResult = z.object({ id: z.string(), delivered: z.number().int() });
//# sourceMappingURL=schemas.js.map